import React from 'react';

const TABS = [
  { key: 'home', label: 'Home' },
  { key: 'songs', label: 'Songs' },
  { key: 'ideas', label: 'Ideas' },
  { key: 'gigs', label: 'Gigs' },
  { key: 'setlist', label: 'Setlist' },
  { key: 'venues', label: 'Venues' },
  { key: 'documents', label: 'Docs' },
];

export default function TabNavigation({ activeTab, setActiveTab }) {
  return (
    <div className="flex gap-2 mb-6 overflow-x-auto pb-1 -mx-4 px-4 sm:mx-0 sm:px-0">
      {TABS.map(tab => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`flex-shrink-0 sm:flex-1 py-2 px-6 font-semibold transition whitespace-nowrap rounded-card-btn text-sm ${
            activeTab === tab.key 
              ? 'bg-brand text-white border border-brand' 
              : 'bg-transparent text-white border border-surface-border-light hover:border-surface-border'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
